import { Back, MapSelect, MapDrawing } from '@watersport/ui-react-icons'
import { Button } from '@watersport/ui-react-next'
import React from 'react'

export interface SelectDrawingModeProps {
  goBack: () => void
  selectDrawingMode: (mode: 'select' | 'drawing') => void
}

const SelectDrawingMode: React.FC<SelectDrawingModeProps> = ({ goBack, selectDrawingMode }) => {
  return (
    <div
      className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center gap-5"
      data-testid="select-drawing-mode-container"
    >
      <Button
        containerClassName="w-[52px] h-[52px] absolute top-4 left-5"
        className="bg-blue-600 rounded-lg shadow-md cursor-pointer hover:bg-blue-600"
        variant={'default'}
        text={<Back width={24} height={24} />}
        onClick={goBack}
        data-testid="go-back-button"
      />
      <div
        className="h-[162px] w-[162px] py-[13px] px-5 rounded-3xl border border-blue-400 bg-white flex flex-col items-center justify-center gap-3"
        onClick={() => selectDrawingMode('select')}
        data-testid="select-mode-button"
      >
        <MapSelect width={36} height={36} className="text-blue-700" />
        <div>
          <div className="text-center text-[22px] font-medium">{'Select'}</div>
          <div className="text-center text-xs font-normal text-gray-700">
            {'location and radius'}
          </div>
        </div>
      </div>
      <div
        className="h-[162px] w-[162px] py-[13px] px-5 rounded-3xl border border-blue-400 bg-white flex flex-col items-center justify-center gap-3"
        onClick={() => selectDrawingMode('drawing')}
        data-testid="drawing-mode-button"
      >
        <MapDrawing width={36} height={36} />
        <div>
          <div className="text-center text-[22px] font-medium">{'Draw'}</div>
          <div className="text-center text-xs font-normal text-gray-700">{'area on the map'}</div>
        </div>
      </div>
    </div>
  )
}

export default SelectDrawingMode
